import React from 'react'
import PropTypes from 'prop-types'
import useOnEvent from 'services/events/use-on-event'
import { usePipeline } from '@morningtrain/react-helpers'

export default function TriggerPipelineOnEvent ({ name }) {
  const pipeline = usePipeline()

  useOnEvent(name, () => {
    const payload = {}

    return new Promise((resolve, reject) => {
      pipeline.trigger(payload)
        .then((p) => {
          resolve(p)
        })
        .catch((err) => {
          reject(err)
        })
    })
  })

  return null
}

TriggerPipelineOnEvent.propTypes = {
  name: PropTypes.string.isRequired
}
